import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type {
  EmailVerificationRequestResponse,
  EmailVerificationResponse,
  User,
} from "@/api/types";

export function useRequestEmailVerification() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      api.post("users/me/email/request_verification").json<EmailVerificationRequestResponse>(),
    onSuccess: (data) => {
      if (data.already_verified) void queryClient.invalidateQueries({ queryKey: ["me"] });
    },
  });
}

export function useVerifyEmail() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (token: string) =>
      api.post("users/me/email/verify", { json: { token } }).json<EmailVerificationResponse>(),
    onSuccess: (data) => {
      queryClient.setQueryData<User | null>(["me"], (user) =>
        user ? { ...user, email_verified_at: data.verified_at } : user,
      );
      void queryClient.invalidateQueries({ queryKey: ["me"] });
      void queryClient.invalidateQueries({ queryKey: ["onboarding-status"] });
      void queryClient.invalidateQueries({ queryKey: ["bookings"] });
      void queryClient.invalidateQueries({ queryKey: ["booking"] });
    },
  });
}
